import script from "./ProfileSingleView.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileSingleView.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__